/**
 * Default function to extract a string label from an option.
 * Used by operator tools to identify options.
 */
export const defaultFormatOptionStringLabel = (option: unknown): string => {
  if (option && typeof option === "object" && "label" in option) {
    const { label } = option as { label?: string };
    return label ?? "";
  }
  return "";
};
